import { useTranslation } from "@/hooks/use-translation"
import { formatMoneyWhole } from "@/lib/billing-format"
import {
  formatSpendLimitPercent,
  formatSpendLimitResetDate,
  formatSpendLimitResetTime,
  spendLimitMonthName,
} from "@/lib/spend-limit"

/**
 * Общие подписи лимитов: время сброса по часам зрителя, месяц периода, проценты, строка расхода.
 * currency — валюта лимита (docs/billing_currency_accounts.md §5); по умолчанию RUB.
 */
export function useSpendLimitText(currency: string = "RUB") {
  const { t, locale } = useTranslation("billing")
  const resetParts = (iso: string) => ({
    date: formatSpendLimitResetDate(iso, locale),
    time: formatSpendLimitResetTime(iso, locale),
  })
  const inProgress = (amount: number) =>
    amount > 0 ? t("spendLimits.inProgressSuffix", { amount: formatMoneyWhole(amount, currency) }) : ""
  return {
    resetsAt: (iso: string) => t("spendLimits.resetsAt", resetParts(iso)),
    resetsAtLower: (iso: string) => t("spendLimits.resetsAtLower", resetParts(iso)),
    resetsOn: (iso: string) => formatSpendLimitResetDate(iso, locale),
    resetTime: (iso: string) => formatSpendLimitResetTime(iso, locale),
    monthIn: (iso: string) => spendLimitMonthName(iso, locale),
    percent: formatSpendLimitPercent,
    inProgress,
    spent: (spent: number, inProgressAmount: number) =>
      `${t("spendLimits.spentPrefix")} ${formatMoneyWhole(spent, currency)}${inProgress(inProgressAmount)}`,
  }
}
